import { render, staticRenderFns } from "./LawStatisitcDetailsPieTable.vue?vue&type=template&id=9790fa40&scoped=true"
import script from "./LawStatisitcDetailsPieTable.vue?vue&type=script&lang=js"
export * from "./LawStatisitcDetailsPieTable.vue?vue&type=script&lang=js"
import style0 from "./LawStatisitcDetailsPieTable.vue?vue&type=style&index=0&id=9790fa40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9790fa40",
  null
  
)

export default component.exports